<app-header></app-header>

<div class="container-fluid my-5 p-t-45">
  <div>
    <p-breadcrumb
      class="max-w-full"
      [model]="breadCrumbItems"
      [home]="breadCrumbHome"
    >
      <ng-template pTemplate="item" let-item>
        <p class="b2 m-b-0">{{ item.label }}</p>
      </ng-template>
      <ng-template pTemplate="separator"> / </ng-template>
    </p-breadcrumb>
  </div>
  <div class="dis-flex flex-m flex-sb">
    <h1 class="font-medium m-b-0">Kanban View</h1>
    <div class="dis-flex">
      <p-dropdown
          [options]="groupFilter"
          class="m-r-5 kanban-filter"
          optionLabel="label"
          [(ngModel)]="selGroups"
          optionValue="value"
          [filter]="true"
          (onChange)="onGroupChange($event)"
          placeholder="Select Group"
          (onFilter)="onGroupSearch($event)"
          [overlayOptions]="helper.getOverlayOptions()"
        />
        <p-dropdown
          *ngIf="this.category!='member'"
          [(ngModel)]="selectMember"
          class="m-r-5 kanban-filter"
          optionLabel="name"
          optionValue="user_id"
          [options]="members"
          filter="true"
          [showClear]="true"
          (onClear)="clearMember()"
          placeholder="Select Member"
          (onChange)="onSelectMember($event)"
          [overlayOptions]="helper.getOverlayOptions()"
        />
      <p-dropdown
        class="m-r-5 kanban-filter fixed-width"
        id="dropdown"
        [options]="outcomeYear"
        placeholder="Select Year"
        [(ngModel)]="sidebarService.selectedKanbanDashboardYear"
        filterPlaceholder="Search"
        [showClear]="false"
        optionLabel="value"
        (onChange)="onKanbanDashboardYearChange($event)"
        [overlayOptions]="helper.getOverlayOptions()"
      >
      </p-dropdown>
      @if(value==='quarterly'){
      <div class="m-r-20">
        <p-dropdown
          class="m-r-5 kanban-filter fixed-width"
          *ngIf="this.category != 'affiliate'"
          [options]="quarter"
          optionLabel="quarterVal"
          [(ngModel)]="selQuater"
          optionValue="quarter"
          (onChange)="onQuarterFilterChange($event.value)"
          placeholder="Select Cycle"
          [overlayOptions]="helper.getOverlayOptions()"
        />
      </div>
      }
      <div
        class="dependency-type radius-8 border-20 bg-white p-t-4 p-b-4 p-r-4 p-l-4"
      >
        <p-selectButton
          *ngIf="this.category != 'affiliate'"
          [options]="stateOptions"
          [(ngModel)]="value"
          optionLabel="label"
          optionValue="value"
          (ngModelChange)="onValueChange(value)"
        />
        <p-selectButton
          *ngIf="this.category == 'affiliate'"
          [options]="[{ label: 'Annual', value: 'annual' }]"
          optionLabel="label"
          optionValue="Annual"
          (ngModelChange)="onValueChange(value)"
        />
      </div>
    </div>
  </div>
  <div class="body-card">
    <div class="kanban-card w-full">
      <div *ngIf="!isKanbanBoardDataLoaded; else kanbanShimmer">
        <app-kanban-column
          [notStartedCount]="notStartedCount"
          [ongoingCount]="ongoingCount"
          [completedCount]="completedCount"
          [terminatedCount]="terminatedCount"
          [delayedCount]="delayedCount"
          [selQuater]="selQuater"
          [category]="category"
          [notstartedData]="notstarted"
          [completedData]="completed"
          [terminatedData]="terminated"
          [ongoingData]="ongoing"
          [delayedData]="delayed"
          [kanbanPayload]="kanbanPayload"
        ></app-kanban-column>
      </div>
      <!-- <div *ngIf="value == 'annual'">
            <app-kanban-column  [kanban]="kanbanCardData"></app-kanban-column>
        </div> -->
    </div>
  </div>

  <!-- <app-quick-action></app-quick-action> -->
</div>

<ng-template #kanbanShimmer>
  <app-kanban-shimmer></app-kanban-shimmer>
</ng-template>
